import React from 'react'
import { StatusBadge } from 'components/Badges'
import { dateToLocale } from 'components/Helpers'
import Amount from 'components/Helpers/Amount'

// Money sent back by the member's bank after a SEPA direct debit was
// collected. Recorded by billing as refunds, but not refunds we made.
const BANK_RETURNS = {
  slimpay_reject: 'bank reject',
  slimpay_return: 'bank return'
}

// Badge text and css class for a refund
export const refundBadge = (refund) => {
  if (BANK_RETURNS[refund.status]) {
    return { status: BANK_RETURNS[refund.status], cssStatus: 'returned' }
  }

  if (refund.status === 'accepted') {
    return { status: 'refund', cssStatus: 'refund' }
  }

  return { status: 'refund declined', cssStatus: 'stopped' }
}

// All refunds on an invoice's payments, each with its payment's currency
export const invoiceRefunds = (payments) =>
  (payments || []).reduce((acc, cur) => {
    (cur.refunds || []).forEach(r => {
      acc.push(Object.assign({ currency: cur.currency }, r))
    })
    return acc
  }, [])

const Refund = ({ refund }) =>
  <span className='refund-row'>
    <StatusBadge {...refundBadge(refund)} />
    <span>{dateToLocale(refund.created_at)}</span>
    <Amount
      className='amount'
      amount={refund.amount}
      currency={refund.currency}
    />
    <span className='comment hidden phone'>
      {refund.comment}
    </span>
  </span>

const Refunds = ({ payments }) => {
  if (payments === undefined) {
    return null
  }

  const refunds = invoiceRefunds(payments)
  if (refunds.length === 0) return ''

  const style = {
    marginTop: '-10px',
    marginBottom: '0px',
    height: `${refunds.length * 30}px`
  }

  return (
    <p className='invoice-refunds hidden phone' style={style}>
      <span style={{ position: 'absolute' }}>
        {refunds.map((r) => {
          return <Refund key={r.id} refund={r} />
        })}
      </span>
    </p>
  )
}

export default Refunds
